module.exports = __webpack_public_path__ + "media/images/athletes/3573-fb91de2dabdf2508f42734e2880ea66f.png";